var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGandalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.02,
    height: 238.515,
    viewBox: "0 0 49.065 64.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41.584 -38.107)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.117,
    cy: 92.634,
    fill: "#c6cab7",
    fillRule: "evenodd",
    paintOrder: "markers stroke fill",
    rx: 19.112,
    ry: 4.701
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4d2b1",
    fillRule: "evenodd",
    d: "M79.008 74.591v.045a1.503 1.503 0 01.213-.015 1.503 1.503 0 011.503 1.503 1.503 1.503 0 01-1.503 1.503 1.503 1.503 0 01-.213-.016v.016H74.22V74.59zM53.827 74.359v.044a1.503 1.503 0 00-.212-.015 1.503 1.503 0 00-1.504 1.503 1.503 1.503 0 001.504 1.503 1.503 1.503 0 00.212-.015v.015h4.788V74.36z",
    paintOrder: "markers stroke fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "M58.673 69.516s-3.716 11.578-3.04 18.402c.556 5.63 7.76 6.016 10.267 5.98v.018s10.457.878 11.131-5.945c.675-6.823-3.04-18.402-3.04-18.402l-7.415.13v-.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9e2",
    d: "M57.779 65.567s-.179 17.145.877 18.464c1.055 1.32 2.475 1.245 2.475 1.245s13.7-.779 13.89-19.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "evenodd",
    d: "M73.977 43.528c-13.538 4-15.445 13.071-15.544 16.976a12.105 3.727 0 00-4.144 2.808 12.105 3.727 0 0012.105 3.727 12.105 3.727 0 0012.104-3.727 12.105 3.727 0 00-4.3-2.85z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d33",
    fillRule: "evenodd",
    d: "M55.635 87.036c.008.188.02.373.034.555h21.454c.013-.182.024-.367.032-.555zM60.509 91.226a1.833 1.833 0 00-1.823 1.833 1.833 1.833 0 00.142.707h3.382a1.833 1.833 0 00.142-.707 1.833 1.833 0 00-1.833-1.833 1.833 1.833 0 00-.01 0zM72.76 91.226a1.833 1.833 0 00-1.823 1.833 1.833 1.833 0 00.142.707h3.382a1.833 1.833 0 00.142-.707 1.833 1.833 0 00-1.833-1.833 1.833 1.833 0 00-.01 0z",
    paintOrder: "markers stroke fill"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    paintOrder: "markers stroke fill"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9e2",
    d: "M78.662 56.182h1.134V90.54h-1.134z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "M78.662 56.182h1.134v2.882h-1.134z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 63.184,
    cy: 68.8,
    r: 0.804,
    fill: "#1d1d33",
    fillRule: "evenodd",
    paintOrder: "stroke markers fill"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.718,
    cy: 68.8,
    r: 0.804,
    fill: "#1d1d33",
    fillRule: "evenodd",
    paintOrder: "stroke markers fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d33",
    fillRule: "evenodd",
    d: "M64.808 68.956v.002a.322.322 0 00-.296.32.322.322 0 00.296.32v.006h2.26a.322.322 0 00.322-.322.322.322 0 00-.322-.322v-.004z",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1d1d33",
    strokeLinecap: "round",
    strokeWidth: 0.661,
    d: "M64.799 69.534s1.135 1.365 2.287.01",
    paintOrder: "stroke fill markers"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGandalf);
export default __webpack_public_path__ + "static/media/gandalf.2d71a5b8.svg";
export { ForwardRef as ReactComponent };